// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component } from 'react';
import ReactSelect from 'react-select';
import CreatableSelect from 'react-select/creatable';
export { createFilter } from 'react-select';

const components = {
  DropdownIndicator: null,
};

const createOption = (label) => ({
  label,
  value: label,
});

const styles = {
  menuPortal: (styles) => ({ ...styles, zIndex: 3000 }),
  input: (styles) => ({ ...styles }),
};

export default function Select(props) {
  return (
    <ReactSelect
      className="react-select"
      classNamePrefix="react-select"
      class
      menuPortalTarget={document.body}
      styles={styles}
      {...props}
    />
  );
}

export class CreatableInputOnly extends Component {
  state = {
    inputValue: '',
    value: [],
  };
  componentDidMount() {
    const { initialValue } = this.props;
    if (this.props.initialValue) {
      this.setState({
        value: initialValue.map((element) => createOption(element)),
      });
    }
  }

  handleChange = (value) => {
    this.setState({ value }, () => {
      this.handleUpdate();
    });
  };
  handleInputChange = (inputValue) => {
    this.setState({ inputValue });
  };
  handleUpdate = () => {
    if (this.props.handleUpdate) {
      this.props.handleUpdate(this.props.path, this.state.value);
    }
  };
  handleKeyDown = (event) => {
    const { inputValue, value } = this.state;

    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
      case ',':
        this.setState(
          {
            inputValue: '',
            value: value
              ? [...value, createOption(inputValue)]
              : [createOption(inputValue)],
          },
          () => {
            this.handleUpdate();
          },
        );

        event.preventDefault();
        break;
      default:
    }
  };
  render() {
    const { inputValue, value } = this.state;
    return (
      <CreatableSelect
        components={components}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={this.handleChange}
        onInputChange={this.handleInputChange}
        onKeyDown={this.handleKeyDown}
        placeholder={this.props.placeholder || 'Type value and press enter...'}
        value={value}
        styles={styles}
        {...this.props}
      />
    );
  }
}
